module.exports = __webpack_public_path__ + "images/b9bc87351c2f71d7f158fad30f1fd07e.svg";